import { SearchPropertyStatus } from '../types';
import { getDefaultSortOption } from './getDefaultSortOption';
import { isValidSortOption } from './isValidSortOption';

export const getValidSortOptionByPropertyStatus = ({
  sortOption,
  propertyStatus,
  isGeoShapeBasedSearch = false,
}: {
  sortOption: string;
  propertyStatus: SearchPropertyStatus;
  isGeoShapeBasedSearch?: boolean;
}): string => {
  const { defaultValue } = getDefaultSortOption({
    isGeoShapeBasedSearch,
    propertyStatus,
  });

  return isValidSortOption(propertyStatus, sortOption) ? sortOption : defaultValue;
};
